import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { tokens } from "@/tokens";

type ChoiceOption = { label: string; value: string };

export type UIChoiceSpec = {
  type: "choice";
  id: string;
  question: string;
  options: ChoiceOption[];
};

export type UIGenSpec = UIChoiceSpec; // Extendable for other UI types later

interface GenerativeUIBlockProps {
  spec: UIGenSpec;
  onSubmit: (payload: { id: string; value: string }) => void;
}

const GenerativeUIBlock: React.FC<GenerativeUIBlockProps> = ({ spec, onSubmit }) => {
  if (spec.type === "choice") {
    return (
      <Box sx={{ border: "1px solid #E6E4E1", borderRadius: 6, p: 1.5, backgroundColor: tokens.bg.surface, mt: 1 }}>
        <Typography variant="body2" fontSize={tokens.fontSize.lg} color="#1a1a1a" sx={{ mb: 1 }}>
          {spec.question}
        </Typography>
        <Stack direction="row" spacing={1} flexWrap="wrap">
          {spec.options.map((opt) => (
            <Button
              key={opt.value}
              variant="outlined"
              size="small"
              onClick={() => onSubmit({ id: spec.id, value: opt.value })}
            >
              {opt.label}
            </Button>
          ))}
        </Stack>
      </Box>
    );
  }

  return null;
};

export default GenerativeUIBlock;


